import parseInfoEvent from 'modules/overlay-v2/store/game-info/utils/parse-info.event';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useFabric from 'ud-ui/components/fabric-canvas/hooks/use-fabric';
import useReplacer from 'ud-ui/components/fabric-canvas/hooks/use-replacer';
import useResizeCanvas from 'ud-ui/components/fabric-canvas/hooks/use-resize-canvas';
import useTemplates from 'modules/template-editor/ui/hooks/use-templates';
import { millisToMinutesAndSeconds } from 'modules/overlay-v2/domain/utils/convert-time';
import { selectEvents } from 'modules/overlay-v2/store/overlay/selectors';
import useGameInfo from 'modules/overlay-v2/ui/hooks/use-game-info';
import useLoadEvent from 'modules/overlay-v2/ui/hooks/use-load-event';
import useTime from 'modules/overlay-v2/ui/hooks/use-time';
import useTimer from 'modules/overlay-v2/ui/hooks/use-timer';

import { CanvasWrapper } from './styles';

export function CanvasEventBoards() {
  const { canvas, manager } = useFabric('static', { id: 'events' });
  const replacer = useReplacer(manager);
  const { activeTemplate } = useTemplates();
  const { timer } = useTimer();
  const { period } = useTime();
  const events = useSelector(selectEvents);
  const gameInfo = useGameInfo();

  const [isManagerInit, setIsManagerInit] = useState(false);

  useLoadEvent({ manager });

  useResizeCanvas({ manager, isManagerInit });

  useEffect(() => {
    if (!manager) return;
    if (!activeTemplate) return;
    manager?.setResolution(activeTemplate.resolution);
    manager?.setDimensions(activeTemplate.resolution);
    manager.normalizedViewport();
    setIsManagerInit(true);
  }, [activeTemplate, manager]);

  useEffect(() => {
    if (!manager) return;
    const { goals, fouls } = gameInfo;

    replacer.updateText({ indicator: 'teamScore0', text: goals.first.toString() });
    replacer.updateText({ indicator: 'teamScore1', text: goals.second.toString() });
    replacer.updateText({ indicator: 'teamFouls0', text: fouls.first.toString() });
    replacer.updateText({ indicator: 'teamFouls1', text: fouls.second.toString() });

    replacer.updateText({ indicator: 'teamScore', text: goals.first.toString(), teamIndex: 0 });
    replacer.updateText({ indicator: 'teamScore', text: goals.second.toString(), teamIndex: 1 });
    replacer.updateText({ indicator: 'teamFouls', text: fouls.first.toString(), teamIndex: 0 });
    replacer.updateText({ indicator: 'teamFouls', text: fouls.second.toString(), teamIndex: 1 });
    replacer.updateTeamPeriodFouls({ indicator: 'teamPeriodFouls', options: { teamIndex: 0, count: fouls.first ?? 0 } });
    replacer.updateTeamPeriodFouls({ indicator: 'teamPeriodFouls', options: { teamIndex: 1, count: fouls.second ?? 0 } });
    // eslint-disable-next-line
  }, [gameInfo.fouls, gameInfo.goals, replacer]);

  useEffect(() => {
    // Обновление счёта в карточе события, так, как там другой placeholder
    const { goals, fouls, teams } = gameInfo;

    const event = events[0];
    if (!event) return;
    const { teamPrefix } = parseInfoEvent(event, teams);
    const { teamPrefix: reversePrefix } = parseInfoEvent(event, teams, { teamReverse: true });

    if (teamPrefix) {
      replacer.updateText({
        indicator: 'score',
        text: goals[teamPrefix].toString().toString(),
        teamReverse: false,
      });

      replacer.updateText({
        indicator: 'fouls',
        text: fouls[teamPrefix].toString().toString(),
        teamReverse: false,
      });
    }

    if (reversePrefix) {
      replacer.updateText({
        indicator: 'score',
        text: goals[reversePrefix].toString().toString(),
        teamReverse: true,
      });

      replacer.updateText({
        indicator: 'fouls',
        text: fouls[reversePrefix].toString().toString(),
        teamReverse: true,
      });
    }
  }, [events, gameInfo, replacer]);

  useEffect(() => {
    if (!manager) return;
    replacer.updateText({ indicator: 'matchTime', text: millisToMinutesAndSeconds(timer) });
    replacer.updateText({ indicator: 'period', text: period.toString() });
  }, [replacer, timer, period, manager]);

  return <CanvasWrapper>{canvas}</CanvasWrapper>;
}
